export default {
  section_title: 'Verokäsittely',
  inherited_from_partner: 'Peritty',
  inherited_from_region: 'Alueen oletus',
  reset: 'Palauta periytyvään',
  form: {
    tax_name: {
      label: 'Veron nimi',
      tooltip: 'Miten vero näkyy kuiteissa ja laskuissa, esimerkiksi ALV tai GST.',
    },
    tax_behaviour: {
      label: 'Verokäsittely',
      tooltip: 'Sisältyvätkö menuhinnat jo veroon, vai lisätäänkö vero kassalla.',
      options: {
        inclusive: 'Sisältyy menuhintoihin',
        exclusive: 'Lisätään kassalla',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Toimitusmaksun verokanta',
      tooltip: 'Verokanta, jolla oma toimitusmaksusi verotetaan, joka voi poiketa ruoan verokannasta.',
    },
  },
  impact: {
    title: 'Muutetaanko ravintoloidesi verokäsittely?',
    affected_one: '{{count}} ravintola noudattaa oletustasi ja muuttuu.',
    affected_other: '{{count}} ravintolaa noudattaa oletustasi ja muuttuu.',
    overriding_one: '{{count}} ravintolalla on oma asetus, joka säilyy.',
    overriding_other: '{{count}} ravintolalla on oma asetus, joka säilyy.',
    confirm: 'Muuta ne',
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    load_error: 'Verotusasetusten lataaminen epäonnistui',
    impact_error: 'Ei onnistuttu tarkistamaan, mihin ravintoloihin tämä vaikuttaisi',
    impact_changed_one: 'Vaikutettujen ravintoloiden määrä muuttui ({{count}}). Tarkista ja tallenna uudelleen.',
    impact_changed_other: 'Vaikutettujen ravintoloiden määrä muuttui ({{count}}). Tarkista ja tallenna uudelleen.',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
};
